import { I18nLocale, t } from '@ardoq/i18n';
import { LabelAndValue } from '@ardoq/suggestions-api';
import { IFilterParams } from 'ag-grid-enterprise';
import React, { useMemo } from 'react';
import { APIComponentAttributes } from '@ardoq/api-types';
import { inventoryDatasourceOperations } from '../datasourceOperations';
import { InventoryContext } from '../types';
import {
  getFilterOptionLabel,
  hasValueSelectOption,
  noValueSelectOption,
} from './agGridFilterOperations';
import { CustomComponentSelectionFilter } from './CustomComponentSelectionFilter';

const getDefaultOptionsGroup = (i18nLocale: I18nLocale) => ({
  label: t(
    i18nLocale,
    'inventoryApp:ag.filter.defaultOptionsGroupLabel',
    'Default options'
  ),
  options: [
    {
      label: getFilterOptionLabel(noValueSelectOption, i18nLocale),
      value: noValueSelectOption,
    },
    {
      label: getFilterOptionLabel(hasValueSelectOption, i18nLocale),
      value: hasValueSelectOption,
    },
  ],
});
const isNoValueOption = (id: string): boolean => id === noValueSelectOption;
const isHasValueOption = (id: string): boolean => id === hasValueSelectOption;

const getResolveSpecialFilterValue =
  (i18nLocale: I18nLocale) =>
  (value: string): LabelAndValue => ({
    label: getFilterOptionLabel(value, i18nLocale),
    value: value,
  });

type ParentComponentFilterProps = IFilterParams<
  APIComponentAttributes,
  InventoryContext
>;

export const ParentComponentFilter = (props: ParentComponentFilterProps) => {
  const workspaceIds = useMemo(
    () =>
      inventoryDatasourceOperations.getWorkspaceIdsFromDatasource(
        props.context.datasourceSelection
      ),
    [props.context.datasourceSelection]
  );

  return (
    <CustomComponentSelectionFilter
      {...props}
      workspaceIdsScopeForSuggestions={workspaceIds}
      getDefaultOptionsGroup={getDefaultOptionsGroup}
      isSpecialValue={value =>
        isNoValueOption(value) || isHasValueOption(value)
      }
      getResolveSpecialFilterValue={getResolveSpecialFilterValue}
    />
  );
};
